import React, {useMemo, useState} from "react";
import ProfileContainer from "../components/ProfileContainer";
import NEWSkillFormButton from "../components/NEWSkillFormButton";

const MAX_LENGTH = 8;

const TalentProfileIndustryExperience = ({items, criteria}) => {

    const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);

    const industries = useMemo(() => {
        let allIndustries = items;
        let criteriaIndustries = criteria?.industries ||[];
        TB.map(TB.values(laravel.importance_levels), imp => {
            if (criteria?.[`${TB.snakeCase(imp)}_industries`]?.length > 0) {
                criteriaIndustries = [...criteriaIndustries, ...criteria[`${TB.snakeCase(imp)}_industries`]]
            }
        })
        if (criteriaIndustries && criteriaIndustries.length > 0) {
            let matchIndustryIds = TB.map(criteriaIndustries, ind => parseInt(ind.id));
            allIndustries = TB.map(allIndustries, ind => {
                return {
                    ...ind,
                    isMatch: matchIndustryIds.includes(ind.id),
                }
            });
            allIndustries = TB.orderBy(allIndustries, 'isMatch', 'desc')
        }
        return allIndustries;
    }, [items, criteria])

    const hasMatchingIndustries = useMemo(() => {
        return TB.filter(industries, ['isMatch', true])?.length > 0;
    }, [industries]);
    return (
        <div id="industry-experience" className="pt-2 pb-8">
            <ProfileContainer>
                <div>
                    <div className="flex flex-row items-start justify-between pb-6">
                        <h4 className="textbold text-lg">
                            Industry Experience {!!industries.length && `(${industries.length})`}
                        </h4>
                        {hasMatchingIndustries && (
                            <div className="flex flex-row items-center gap-1.5">
                                <div className="h-2 w-2 rounded-full bg-wripplePrimaryPaleGreen"/>
                                <span className="text-xs italic">
                                    Indicates Match
                                </span>
                            </div>
                        )}
                    </div>

                    {!industries.length && (
                        <div className="py-8 text-center">
                            <p className="text-base">No Industries Available</p>
                        </div>
                    )}

                    <div className="flex gap-4 flex-wrap">
                        {industries?.slice(0, isIndustriesOpen ? industries?.length : MAX_LENGTH).map(industry => {
                            return (
                                <NEWSkillFormButton
                                    key={industry.id}
                                    className="has-skill"
                                    isMatch={industry.isMatch}
                                    readonly
                                    skill={industry}
                                />
                            )
                        })}
                    </div>

                    {industries.length > MAX_LENGTH && (
                        <div className="pt-6 flex justify-end">
                            <button
                                type="button"
                                className="btn-outline flex items-center gap-2 p-1.5 px-2.5 transition hover:bg-wrippleOffWhite"
                                onClick={() => setIsIndustriesOpen(!isIndustriesOpen)}
                            >
                                <p>{industries.length - MAX_LENGTH} {isIndustriesOpen ? 'less' : 'more'}</p>
                                <div className="bg-wrippleOffWhite h-6 w-6 shrink-0 flex items-center justify-center">
                                    <i className={TB.mapClass("fa fa-chevron-down transition text-base", { 'rotate-180': isIndustriesOpen })} />
                                </div>
                            </button>
                        </div>
                    )}

                </div>
            </ProfileContainer>
        </div>

    )
}

export default TalentProfileIndustryExperience;